export class SearchLocationVm {
  brandId?: number;
  userId?: number;
  name?: string;
}
